export default "__VITE_ASSET__baebe510__"